type Key = 'sessionId' | 'name' | 'email' | 'phone' | 'newsletter' | 'selectedPaymentGateway'

// Avoid conflicts with other sessionStorage variables on same domain
const KEY_PREFIX = 'kinola_'

export const Storage = {
    get: (key: Key) => sessionStorage.getItem(KEY_PREFIX + key) ?? '',

    update: (values: Partial<Record<Key, string>>) => {
        for (const [key, value] of Object.entries(values)) {
            sessionStorage.setItem(KEY_PREFIX + key, value)
        }
    },
}
